import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const schema = Yup.object({
  name: Yup.string().required("Name is required"),
  slug: Yup.string().required("Slug is required"),
  billingEmail: Yup.string().email("Invalid email").nullable(),
  billingCurrency: Yup.string().nullable(),
  contactName: Yup.string().nullable(),
  contactPhone: Yup.string().nullable(),
  notes: Yup.string().nullable(),
});

export default function CustomerForm({ initialValues, onSubmit, onCancel, submitLabel = "Save" }) {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      slug: "",
      billingEmail: "",
      billingCurrency: "SEK",
      contactName: "",
      contactPhone: "",
      notes: "",
      ...initialValues,
    },
    validationSchema: schema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const field = (name, label, type = "text") => (
    <div>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={type}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="w-full border rounded px-3 py-2 mt-1"
      />
      {formik.touched[name] && formik.errors[name] && (
        <div className="text-red-500 text-sm">{formik.errors[name]}</div>
      )}
    </div>
  );

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      {field("name", "Name")}
      {field("slug", "Slug")}
      {field("billingEmail", "Billing Email", "email")}
      {field("billingCurrency", "Billing Currency")}
      {field("contactName", "Contact Name")}
      {field("contactPhone", "Contact Phone")}
      <div>
        <label htmlFor="notes" className="block text-sm font-medium text-gray-700">
          Notes
        </label>
        <textarea
          id="notes"
          name="notes"
          rows={3}
          value={formik.values.notes}
          onChange={formik.handleChange}
          className="w-full border rounded px-3 py-2 mt-1"
        />
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 rounded">
          Cancel
        </button>
        <button
          type="submit"
          disabled={formik.isSubmitting}
          className="px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          {formik.isSubmitting ? "Saving…" : submitLabel}
        </button>
      </div>
    </form>
  );
}
